import { PersonalSetting } from '@ardoq/api-types';
import { ConfirmResult, ModalSize, confirm } from '@ardoq/modal';
import { userOperations } from '@ardoq/core';
import { t } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { dispatchAction } from '@ardoq/rxbeach';
import { type CurrentUserState } from 'streams/currentUser/currentUser$';
import { updatePersonalSetting } from 'streams/currentUser/actions';

export const confirmCloseAllDatasets = async (
  currentUser: CurrentUserState
) => {
  const isSuppressConfirmDialog = userOperations.getPersonalSetting(
    currentUser,
    PersonalSetting.DONT_SHOW_CLOSE_VIEW_BUILDER_CONFIRMATION
  );
  if (isSuppressConfirmDialog) return true;

  // i18nLocale$.state OK here: snapshot-at-open-time; @ardoq/modal renders confirm() body once and does not re-render on locale change
  const i18nLocale = i18nLocale$.state;
  const { rememberAction, confirmed } = (await confirm({
    title: t(
      i18nLocale,
      'viewpointNavigator:confirmCloseAll.title',
      'Close all datasets?'
    ),
    text: (
      <>
        <p>
          {t(
            i18nLocale,
            'viewpointNavigator:confirmCloseAll.body1',
            'All opened datasets will be closed.'
          )}
        </p>
        <p>
          {t(
            i18nLocale,
            'viewpointNavigator:confirmCloseAll.body2',
            'Remember to save datasets you need as Viewpoints or presentation slides before they get closed.'
          )}
        </p>
      </>
    ),
    confirmButtonTitle: t(
      i18nLocale,
      'viewpointNavigator:confirmCloseAll.confirmButton',
      'Close all datasets'
    ),
    confirmButtonClickId: 'close-all-datasets-modal-confirm',
    confirmButtonDataTestId: 'close-all-datasets-modal-confirm',
    cancelButtonTitle: t(
      i18nLocale,
      'viewpointNavigator:confirmCloseAll.cancelButton',
      'Cancel'
    ),
    cancelButtonClickId: 'close-all-datasets-modal-cancel',
    cancelButtonDataTestId: 'close-all-datasets-modal-cancel',
    showRememberActionCheckbox: true,
    rememberActionCustomCheckboxText: t(
      i18nLocale,
      'viewpointNavigator:confirmCloseAll.rememberAction',
      "Don't show this again"
    ),
    modalSize: ModalSize.S,
  })) as ConfirmResult;

  if (rememberAction) {
    dispatchAction(
      updatePersonalSetting({
        personalSetting:
          PersonalSetting.DONT_SHOW_CLOSE_VIEW_BUILDER_CONFIRMATION,
        newValue: true,
      })
    );
  }

  return confirmed;
};
